import { Card, CardContent } from "@/components/ui/card";
import { cn } from "@/lib/utils";
import { PropsWithChildren } from "react";

interface SectionCardProps extends PropsWithChildren {
  onClick?: () => void;
  className?: string;
}

export function SectionCard({ onClick, children, className }: SectionCardProps) {
  return (
    <Card
      className={cn("cursor-pointer border-0 bg-transparent", className)}
      onClick={onClick}
    >
      <CardContent className="p-0">
        {children}
      </CardContent>
    </Card>
  );
}

